<template>
  <div>
    <el-main>
      <el-tabs v-model="activeName">
        <el-tab-pane label="URL配置"
                     name="url">
          <urls />
        </el-tab-pane>
        <el-tab-pane label="角色管理"
                     name="roles">
          <roles />
        </el-tab-pane>
        <el-tab-pane label="开发配置"
                     name="user">
          <config />
        </el-tab-pane>

      </el-tabs>

    </el-main>

  </div>
</template>

<script>

// import axios from 'axios'
import moment from 'moment'
import urls from './developer/urls'
import roles from './developer/roles'
import config from './developer/config'
export default {
  name: 'ele',
  data: function () {
    return {
      activeName: 'roles'

    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    }
  },
  components: {
    urls, roles, config
  },
  computed: {

  },
  methods: {

  },

  mounted () {

  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/app/developer.vue